// extracted by mini-css-extract-plugin
export default {"pageSubHeader":"page-sub-header_pageSubHeader__B+mHv"};